var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroTechImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 476.72 457.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{opacity:0.79;}.cls-4{clip-path:url(#clip-path-3);}.cls-5{fill:#fdbb5b;}.cls-6{fill:#fff;}.cls-7{fill:#52ffd4;}.cls-8{fill:#121e38;}.cls-9{fill:#20282f;}.cls-10{fill:#1b232c;}.cls-11{fill:#293036;}.cls-12{fill:#ee8587;}.cls-13{fill:#ee9585;}.cls-14{fill:#b5bdf1;}.cls-15{fill:#99a0d6;}.cls-16{fill:#ffa644;}.cls-17{fill:#8484fd;}.cls-18{fill:#706cd4;}.cls-19{fill:#e0e4ff;}.cls-20{fill:#3a2f8b;}.cls-21{fill:#5f58df;}.cls-22{fill:#ffd598;}.cls-23{fill:#e27e75;}.cls-24{fill:#a4ffe9;}.cls-25{fill:#cb5863;}.cls-26{fill:#e07c74;}.cls-27{fill:#322483;}.cls-28{fill:#26185c;}.cls-29{fill:#ae3c36;}.cls-30{fill:#8e3442;}.cls-31{fill:#ff99b4;}.cls-32{fill:#404174;}.cls-33{fill:#525582;}.cls-34{fill:#7b7d9d;}.cls-35{fill:#dcfff6;}.cls-36{opacity:0.73;}.cls-37{clip-path:url(#clip-path-4);}.cls-38{fill:#4770b9;}.cls-39{clip-path:url(#clip-path-5);}.cls-40{clip-path:url(#clip-path-6);}.cls-41{clip-path:url(#clip-path-7);}.cls-42{clip-path:url(#clip-path-8);}.cls-43{clip-path:url(#clip-path-9);}.cls-44{clip-path:url(#clip-path-10);}.cls-45{clip-path:url(#clip-path-11);}.cls-46{clip-path:url(#clip-path-12);}.cls-47{opacity:0.76;}.cls-48{clip-path:url(#clip-path-13);}.cls-49{fill:#abb9d2;}.cls-50{fill:#ff69d5;}.cls-51{fill:#5536a6;}.cls-52{fill:#d5d5ff;}.cls-53{fill:#9191ff;}.cls-54{fill:#bcbcff;}.cls-55{fill:#8787f6;}.cls-56{opacity:0.44;}.cls-57{clip-path:url(#clip-path-14);}.cls-58{clip-path:url(#clip-path-15);}.cls-59{clip-path:url(#clip-path-16);}.cls-60{clip-path:url(#clip-path-17);}.cls-61{opacity:0.83;}.cls-62{clip-path:url(#clip-path-18);}.cls-63{clip-path:url(#clip-path-19);}.cls-64{fill:#b5ffed;}.cls-65{clip-path:url(#clip-path-20);}.cls-66{fill:#2be1d2;}.cls-67{clip-path:url(#clip-path-21);}.cls-68{clip-path:url(#clip-path-22);}.cls-69{clip-path:url(#clip-path-23);}.cls-70{clip-path:url(#clip-path-24);}.cls-71{clip-path:url(#clip-path-25);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 476.71,
    height: 457.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.71,
    y: 37.7,
    width: 147.49,
    height: 102.62
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.74,
    y: 150.63,
    width: 173.16,
    height: 161.47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.62,
    y: 161.78,
    width: 57.92,
    height: 122.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.81,
    y: 175.9,
    width: 52.59,
    height: 111.54
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.32,
    y: 199.65,
    width: 44.35,
    height: 91.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.98,
    y: 237.05,
    width: 32.38,
    height: 57.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.34,
    y: 159.28,
    width: 65.76,
    height: 50.45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.31,
    y: 105.93,
    width: 59.96,
    height: 54.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 126.24,
    y: 113.52,
    width: 31.04,
    height: 42.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 109.09,
    y: 172.96,
    width: 56.26,
    height: 57.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 280.82,
    y: 138.17,
    width: 159.42,
    height: 167.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 443.64,
    width: 33.08,
    height: 68.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.01,
    y: 354.47,
    width: 33.08,
    height: 68.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.06,
    y: 374.89,
    width: 33.08,
    height: 68.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.77,
    y: 189.77,
    width: 33.08,
    height: 68.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.07,
    y: 6.24,
    width: 46.25,
    height: 46.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 28.45,
    width: 46.25,
    height: 46.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.34,
    y: 6.95,
    width: 13.82,
    height: 66.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.16,
    y: 4.13,
    width: 60.08,
    height: 19.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 368.43,
    y: 358.77,
    width: 46.25,
    height: 46.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352.36,
    y: 380.98,
    width: 46.25,
    height: 46.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 402.69,
    y: 359.48,
    width: 13.82,
    height: 66.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352.51,
    y: 356.66,
    width: 60.08,
    height: 19.97
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    className: "cls-5",
    d: "M79.65,37.71,189,40c1.76,0,3.41,1.13,3.7,2.45l20.43,93a3.09,3.09,0,0,1-3.19,3.87l-140.24,1a3.69,3.69,0,0,1-4-4L76,40.08c.14-1.36,1.77-2.41,3.64-2.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    className: "cls-6",
    d: "M87.43,77.64l58.9.59c2,0,3.73,1.36,3.88,3L154,122.92a3.5,3.5,0,0,1-3.72,3.7l-66.19.22a3.64,3.64,0,0,1-3.92-3.75l3.27-42.46c.13-1.68,1.9-3,4-3",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    className: "cls-7",
    d: "M88.67,116.39l51.57,0L123.52,89.26,108.92,104l-9.06-6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    className: "cls-6",
    d: "M89,41.74,183,43.6a2.83,2.83,0,0,1,2.78,1.88c.2,1-.72,1.82-2.07,1.8l-95-1.78c-1.43,0-2.51-.9-2.43-1.94s1.28-1.85,2.69-1.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    className: "cls-6",
    d: "M88.46,49.36l96,1.7A2.9,2.9,0,0,1,187.32,53c.21,1.05-.73,1.9-2.11,1.88l-97-1.61c-1.45,0-2.56-.93-2.48-2s1.32-1.93,2.76-1.9",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    className: "cls-6",
    d: "M87.9,57.31,186,58.83a3,3,0,0,1,2.92,2c.21,1.1-.74,2-2.15,2L87.62,61.4c-1.49,0-2.62-1-2.53-2.1s1.34-2,2.81-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    className: "cls-6",
    d: "M87.32,65.61l100.2,1.33a3.05,3.05,0,0,1,3,2.11c.23,1.15-.74,2.08-2.18,2.06L87,69.89c-1.52,0-2.67-1-2.58-2.19a2.66,2.66,0,0,1,2.88-2.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    className: "cls-6",
    d: "M161.4,75.11l27.75.3a3.12,3.12,0,0,1,3,2.19c.24,1.21-.75,2.18-2.22,2.17l-28-.27a2.9,2.9,0,0,1-3-2.24c-.14-1.23.94-2.17,2.42-2.16",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    className: "cls-6",
    d: "M162.48,84l28.37.24A3.21,3.21,0,0,1,194,86.55c.25,1.27-.75,2.29-2.26,2.27L163,88.62a3,3,0,0,1-3-2.33C159.87,85,161,84,162.48,84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    className: "cls-6",
    d: "M163.61,93.35l29,.17a3.3,3.3,0,0,1,3.21,2.39c.27,1.33-.76,2.39-2.3,2.39l-29.34-.13a3.07,3.07,0,0,1-3.11-2.44,2.27,2.27,0,0,1,2.52-2.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    className: "cls-6",
    d: "M164.8,103.13l29.69.09a3.39,3.39,0,0,1,3.3,2.5,2.13,2.13,0,0,1-2.34,2.51l-30,0a3.15,3.15,0,0,1-3.18-2.55,2.34,2.34,0,0,1,2.57-2.5",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    className: "cls-6",
    d: "M166,113.38h30.4a3.52,3.52,0,0,1,3.4,2.61,2.22,2.22,0,0,1-2.39,2.65l-30.76,0a3.24,3.24,0,0,1-3.27-2.66,2.43,2.43,0,0,1,2.62-2.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    className: "cls-6",
    d: "M167.35,124.15l31.14-.08A3.61,3.61,0,0,1,202,126.8a2.32,2.32,0,0,1-1.76,2.75,2.49,2.49,0,0,1-.67,0l-31.53.13a3.36,3.36,0,0,1-3.36-2.79,2.53,2.53,0,0,1,2.26-2.77,3.09,3.09,0,0,1,.43,0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    className: "cls-8",
    d: "M229.74,442.69a3.72,3.72,0,0,0,.61,2.34s19.54-.67,21.68-.77,1.89,1.19,3.65,1.14,15.5-1.51,17.52-2,1.52-6,1.52-6L235,440.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    className: "cls-8",
    d: "M248,420.47c1.4,4.73-.2,8-3.1,10.75s-7.73,2.18-11.68,3.54-4.11,6.87-3.45,8,42.83-1.38,45-2.86,2.25-8.68,1.55-12.64a38.22,38.22,0,0,0-2.24-7.49Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    className: "cls-8",
    d: "M257.91,420.18l-9.89.28c1.4,4.74-.2,8-3.1,10.76-1.82,1.7-4.39,2.13-7,2.54h0c2.52,2.87,2.46,3.32,8.18,1.83s10.76-3.58,11.9-8.06a17.56,17.56,0,0,0-.06-7.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    className: "cls-8",
    d: "M296.84,449.94s.56,6.34,2.45,6.92,19.73,1.31,23.45.6,1.35-7.65,1.35-7.65Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    className: "cls-8",
    d: "M297.17,421.68s1.5,10.95.28,18.51-1.5,11.84,3.3,13.88,17.56,1.54,21.76.78,4.77-8.82,3.44-13.74-5.44-7.65-6.7-12.76-2.87-13-2.87-13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    className: "cls-8",
    d: "M302.63,420.29a38.82,38.82,0,0,1,1,11.62c-.47,6.28-1.36,13.18,5.15,14.16s10.45-.61,10.29-5.71-1.69-6.21-3.67-13-3.69-13-3.69-13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    className: "cls-9",
    d: "M221.4,274s6.5,56.52,13.37,97.49,11.09,51.35,11.09,51.35,1.76,1.46,11.6,1.08S276,422.39,276,422.39l-9.88-121.63-1.93-30Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    className: "cls-10",
    d: "M261.18,271l-29.11,2.19,7.82,31.29,7.65,4.15L264.1,423.56c6.78-.49,11.85-1.17,11.85-1.17l-9.88-121.63-1.68-26.07Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    className: "cls-11",
    d: "M234.19,269.85l9.67,30.64,6.2,1.35L291.1,423s4.11,4.36,15.89,2.55,13.92-10.11,13.92-10.11L287.8,267.06s-12.5-8.38-21.9-8.35-31.71,11.15-31.71,11.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    className: "cls-10",
    d: "M265.9,258.7c-9.39,0-31.71,11.15-31.71,11.15l5.59,17.71a197.46,197.46,0,0,0,21.61,3.57s4.61,17.46,7.26,18.5,17,4.34,17,4.34l26.15,110.3c7.55-2.94,9.07-8.83,9.07-8.83L287.8,267.06s-12.5-8.38-21.9-8.36",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    className: "cls-12",
    d: "M142.44,190.33s-6.65.93-7.82,2-2.37,3.53-4.57,5.85.72,3.94,3.45,3.61,5.8-5.61,6.52-5.72,4.38.42,5.9.5,2.34-1.4.84-3.75a5.84,5.84,0,0,0-4.32-2.48",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    className: "cls-12",
    d: "M136.1,187.91s-8.4,2.68-12.24,3.61-3.65,2.78-.08,4.32,17.93-4,18.76-4.53,1.28-1.18-.92-2.36a12.6,12.6,0,0,0-5.52-1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    className: "cls-12",
    d: "M138.87,185.52s-7.27-.18-12.58-.89-7.77.15-6.24,3.11,16.43,2.52,20,3.13,5.88.35,4.73-1.77-5.88-3.58-5.88-3.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    className: "cls-13",
    d: "M172.37,192.92s-16.88-6.66-18.83-7.21S141.38,183,141.38,183s-10.73-3.11-13.81-5-3.77.25-3,2.57,4.6,3.75,7.19,4.77,8.92,3.27,8.92,3.27,5,3,5.59,6.37-4.68,4.06-6.53,4.25-8.22-.4-7.83,2.87,3.64,3.54,6.42,3.21,4.27-1.33,7.51-1.28,8.86.49,12.39,2.13a16.21,16.21,0,0,0,6.88,1.49Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    className: "cls-14",
    d: "M239.36,168.37c-8.82-1.62-15.47,4.29-17.59,8.64s-16.23,29.7-16.23,29.7L176.44,189c-3.73,1.37-4.64,2.28-8.31,4.63,0,0-4.92,3.74-7.36,8.39-3.42,6.51-3.53,9.5-3.53,9.5s46,35.13,49.29,36.43,9.87.16,9.87.16,28.35-38,33.32-52.23-10.36-27.52-10.36-27.52",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    className: "cls-15",
    d: "M241.1,170.06a16.86,16.86,0,0,0-3.49,2.08c-10.24-1.83-20.73,19-23,28.29s-6.77,22.22-6.77,22.22a13.84,13.84,0,0,1-2.87-5.26c-.55-2.63-1.36-5.78-1.36-5.78l.78,15L160,203.51c-2.68,5.48-2.79,8-2.79,8s46,35.12,49.29,36.42,9.87.16,9.87.16,23.64-31.67,31.52-48c.86-5.74,1.63-10.73,2.18-14.94-1.68-6.81-6.42-12.43-9-15.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    className: "cls-5",
    d: "M220.24,277.19s10.58,4.44,30.84,4.94S290.67,274,290.67,274s-7.87-30.44-8.34-48.89,2.59-46.05,2-50.92-11.25-13.13-17.59-14-17.38.16-21.61,2.31-7.27,8.57-10.1,16.4-12.2,42.08-13.51,60.1-1.26,38.28-1.26,38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    className: "cls-16",
    d: "M272.21,162.09a31.45,31.45,0,0,0-7.11,2c-11.3,27.34-12.2,61.73-12.27,78.84s-.73,26.26-7.83,31.76-18.26,2.81-18.26,2.81l.1,1.63a115,115,0,0,0,24.24,2.95A91.31,91.31,0,0,0,275.59,279c1.22-23.56,4.94-96.85,4.38-111.38a36.05,36.05,0,0,0-7.76-5.56",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    className: "cls-17",
    d: "M244.42,166.2l1.46,3.65S233.12,193.12,231,226s3.73,75.61,3.46,77.5-3.79,1.19-3.79,1.19l-1.13,2.43-9.73-.06s-7.16-13.3-5.45-54.34,12.18-72.51,17.62-80.51,10.37-10.59,10.37-10.59Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    className: "cls-18",
    d: "M242.32,161.56a23,23,0,0,0-4.76,3.8c.57,1.41,1.05,2.33,1.05,2.33a209.58,209.58,0,0,0-14.93,56c-3.94,32.1-1,63.35.22,71.31.8,5.38-2.23,9.5-4.29,11.62l.17.34,9.73.06,1.12-2.43s3.53.7,3.8-1.19S228.82,258.77,231,226s14.91-56.1,14.91-56.1l-1.46-3.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    className: "cls-19",
    d: "M265.2,168.48l-3.09,1.15s-7.7,29.67-5,70.87S268,302,269,302.77s6-1.41,6-1.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    className: "cls-17",
    d: "M271.13,160.51s15.32,4.14,21.55,8.38,8.45,13.67,6.43,28.46-10.7,35.14-11.57,40.35,23.75,48.62,24.28,52.57-8.62,12.21-20.31,14.16-18.14-.59-18.14-.59-13.83-31.48-13.24-71.7,4.28-65.65,4.28-65.65Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    className: "cls-18",
    d: "M271.13,160.51l-6.72,6s-.28,2-.7,5.59a31.12,31.12,0,0,0,12.16-3.36s9.44,3.63,11.37,9.71-10.67,59.16-10.67,59.16,20.68,45.89,21.57,53.89c.69,6.23-17.37,9.58-25.43,10.76.41,1,.66,1.6.66,1.6s6.45,2.55,18.14.6,20.85-10.23,20.32-14.17-25.15-47.36-24.28-52.57,9.54-25.56,11.56-40.35-.2-24.22-6.43-28.46-21.55-8.38-21.55-8.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    className: "cls-20",
    d: "M279.43,150.94c-4.09-2.95-13.19-2.36-18.11-1s-11.39,3.31-11.39,3.31l1.19,9.24s7-3.4,13.85-2.16,9,2.73,9,2.73,1.61.35,3.35-3,2.08-9.15,2.08-9.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    className: "cls-21",
    d: "M250.63,152.16s-9,2.91-10.3,3.58.26,5.38.8,6.71.73,3.37,2.36,3.1,6.59-1.69,6.59-1.69,2.51-3.87,2.53-6.46a10.24,10.24,0,0,0-2-5.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    className: "cls-22",
    d: "M248.56,163a1.65,1.65,0,0,0-1.83,1.11c-.37,1.32,2.69,3.65,7.71,4.19s13.29-.88,14.95-1.38,2.4-2,1.64-3.13-3.3-2-3.3-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    className: "cls-23",
    d: "M270.56,140.63c-1.67,10.47,0,22.76,0,22.76a41.47,41.47,0,0,1-13.07,3.1c-7,.4-9.57-3.23-9.57-3.23s2.1-2.77,2.05-9.32a93.46,93.46,0,0,0-1.23-13.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    className: "cls-21",
    d: "M278.3,150.3c-.26,3.82-4.75,4.51-9.66,5.65s-7.58,1.6-7.64,3.07-.41,10.17,1.31,11.44,11.16-2.33,14.44-3.56,5-3.77,5.09-4.87a64.9,64.9,0,0,0-.95-9.73,2.75,2.75,0,0,0-2.59-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    className: "cls-19",
    d: "M244.57,166.6s-12.54,9.27-17.28,63.28c-3.28,37.46.57,62.91,3.23,75l.11-.24s3.53.7,3.8-1.19S228.82,258.78,231,226s14.91-56.1,14.91-56.1l-1.3-3.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    className: "cls-24",
    d: "M249.21,143.58l0,.22a88.19,88.19,0,0,1,.76,10.14c.05,6.55-2.05,9.31-2.05,9.31a2.92,2.92,0,0,0,.32.38,16.28,16.28,0,0,0,2.16-7.51,67.83,67.83,0,0,0-1.16-12.55Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    className: "cls-25",
    d: "M248.71,140.59q.79,4.88,1.11,9.8a66.25,66.25,0,0,0,14-1.59c2.61-.62,4.57-1.13,6-1.55a61.06,61.06,0,0,1,.66-6.62Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    className: "cls-13",
    d: "M221.52,175.85s.82-4.9-.41-7.77-5.53-6.92-6.73-10.67-4.22-.53-3.86,2.8,2.61,5.35,3.59,9,.14,5.42,2.29,6.22a10.13,10.13,0,0,0,4.67.35Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    className: "cls-26",
    d: "M212.7,155.74c-1.2.16-2.41,2.29-2.18,4.47.35,3.33,2.61,5.34,3.59,9,.89,3.35.28,5.08,1.77,6a3,3,0,0,0,2.93-1.7c.15-4.72.92-4.47-.73-7.39s-2.89-3.63-4.21-7c-.53-1.36-.91-2.5-1.17-3.39m6.11,17.78c0,.06,0,.11,0,.16l.1-.35-.09.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    className: "cls-14",
    d: "M229.77,174.66c-12.34,6.32-18.69,21.5-18.69,21.5s36.56,32.63,40.43,34.84,45.87-22.32,54.9-27.8c9.39-5.68,14.08-22.47,2.31-29.91s-20.45,2.85-25.67,6.61c-7.43,5.35-25.55,18.49-25.55,18.49Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    className: "cls-13",
    d: "M213,195.52c-1.58-1.46-6.75-4.07-9.05-6.72S196.11,172,196.11,172a22.09,22.09,0,0,1,8.24-8.35c5.38-2.85,9.1-2.9,9.1-2.9s7.7,14.23,8.93,15.11,4.08,3.21,4.08,3.21Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    className: "cls-13",
    d: "M214,161.68s-3.89-8.83-5.19-10.76-7-6-8.54-8-3.64-1-2.75,2.83a27.59,27.59,0,0,0,4.71,9.92c1.92,2.53,5.58,9.28,5.58,9.28s2.55-.91,4.21-1.63,2-1.59,2-1.59",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    className: "cls-13",
    d: "M209.67,162.91s-5.61-8-6.69-9.49-6.72-5.1-8.56-6.95-3.94-1.05-3.14,2.2,4,6.51,5.42,8.2,4.78,9.83,4.78,9.83a7.73,7.73,0,0,0,4.3-.62,20.13,20.13,0,0,0,3.89-3.17",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    className: "cls-13",
    d: "M203.84,166s-7.45-8.31-9.21-9.43-5-3-7.39-4.29-4,2.42-2.58,4.82,8.43,7,10.49,8.56a53.21,53.21,0,0,1,4.73,4.41,4.26,4.26,0,0,0,2.49-1.2,3.9,3.9,0,0,0,1.47-2.87",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    className: "cls-13",
    d: "M200.64,169.13s-7.08-7-9.59-8.7-3.52-3.29-5-3.06-2,4.32,0,7,9.4,7.16,10.94,9.51,2.51.21,3.44-1.61a3.27,3.27,0,0,0,.14-3.11Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    className: "cls-26",
    d: "M198.66,141.85c-1,0-1.68,1.35-1.1,3.85a25.22,25.22,0,0,0,1.52,4.46l-.52-.39.43.47a29.75,29.75,0,0,1,3.8,2.8c.92,1,6.11,8.63,6.11,8.63a1.88,1.88,0,0,0,.6-2.06c-.41-1.34-1.3-3.31-4-6.21s-3.58-4-3.58-4a8.58,8.58,0,0,1-1.53-2.29,8,8,0,0,1-.33-4.44,1.93,1.93,0,0,0-1.43-.79m-6.25,3.64c-1,.07-1.64,1.15-1.14,3.17.8,3.25,4,6.52,5.43,8.21a21.57,21.57,0,0,1,2,3.54c-.8-.83-1.58-1.63-2.27-2.29,1.18,1.24,2,2.15,2,2.15l5.24,5.31a1.72,1.72,0,0,0,.62-1.6c-.26-.87-3.29-5-4.78-7.66a48.89,48.89,0,0,0-5.47-7.55c-1.25-1.43-1.18-2.6-.72-3.1a2,2,0,0,0-.9-.18m-8,8a4.16,4.16,0,0,0,.24,3.56,4.83,4.83,0,0,0,.54.72,1.59,1.59,0,0,1,1.3-.37c1.09.15,1.4.85,3.47,2s9.9,8.71,9.9,8.71a3.15,3.15,0,0,0-.59-2.85c-1.1-1.15-6.39-6.4-9.08-8.14s-2.78-2-4.49-2.31a1.61,1.61,0,0,1-1.29-1.31m.52,8.24a6.46,6.46,0,0,0,1.18,2.58c1.91,2.46,8.4,6.54,10.54,9,1.41,3.55,5.4,13.3,7.29,15.47,2.3,2.65,7.47,5.26,9.05,6.72l1.85-2.27c-1.51-1.09-3.84-2.77-6.27-4.55-3.48-2.55-8.46-13.08-9.72-15.16s-.94-2.48-3.09-3.66-6-4.56-8.37-6.19a16.34,16.34,0,0,1-2.46-1.93",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    className: "cls-15",
    d: "M302,170.75c8.26,5.08,8.61,13.19,7.21,18.75-1.75,7-52.82,28.54-52.82,28.54s-1.47-2.23-1.28-6.89a45.3,45.3,0,0,1,1.12-8.28s-3.69,4.64-4.28,7.54a17.67,17.67,0,0,0-.08,5.85s-31.72-20.82-31.42-24.9c.24-3.28,6.23-12.66,8.63-16.3-11.85,6.54-18,21.1-18,21.1S247.63,228.79,251.5,231s45.88-22.33,54.91-27.8c9.39-5.68,14.08-22.47,2.31-29.91a16.35,16.35,0,0,0-6.77-2.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    className: "cls-27",
    d: "M231.32,102.12c-5-2.53-8.39-6.13-8.09-10.2a5.4,5.4,0,0,1,4.27-4.84,6.26,6.26,0,0,1-1.17-3.7,2.68,2.68,0,0,1,1.46-2.48,6.05,6.05,0,0,1-4.23-7.67c1.57-6.12,7.94-3.79,7.94-3.79s-2.09-6.73,4.77-8.83,9.1,2,15.06,6.88,17.32,9,26.73,9,12.35-.67,17.84,5.52,5.69,18,5.82,21.79-3.3,21.42-3.13,30,1.61,11.37-3.92,12.55-8-3.81-8-3.81.14,2.16-5.62,2-9.17-9-9.17-9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    className: "cls-28",
    d: "M282.74,76.47c-1.37,0-2.91,0-4.68,0h-.2c4.09,5.84-3.51,16.31-3.51,16.31s.18,8.37.16,13.27c0,3.48-2.41,19.72-2.19,30.46,1.09,2.31,4.17,7.87,8.73,8,5.76.18,5.62-2,5.62-2s2.47,5,8,3.81,4.08-4,3.91-12.55,3.26-26.21,3.13-30-.34-15.6-5.82-21.79c-4.45-5-7.22-5.51-13.16-5.53",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    className: "cls-13",
    d: "M229,100.64c0,8-1.82,10.32-2.68,18.19s1.65,20.91,12,23.49,28.22,2.48,37.62.78,10.88-15.52,10.88-15.52,4.43,3.34,8.6,1,8.3-9.09,3.21-13.32-10.31.66-10.31.66l-.08-6.65s.57,2.2-2.88,3.89-4.49-5.9-4.49-5.9a8.88,8.88,0,0,1-5.34-.85c-2.82-1.4-3.55-9-3.55-9s-3.92-7.81-11.21-8.19-18.15,1.2-22.37,2.23A9.82,9.82,0,0,1,231,90.35s-1.51,7.46-2,10.3",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    className: "cls-24",
    d: "M239.69,60a11.67,11.67,0,0,0-3.42.57c-6.86,2.1-4.77,8.83-4.77,8.83s-6.37-2.33-7.93,3.79a6.06,6.06,0,0,0,4.22,7.68,2.66,2.66,0,0,0-1.46,2.47,6.31,6.31,0,0,0,1.17,3.71,4.77,4.77,0,0,0-.62.17c.38.22.61.33.61.33a4.79,4.79,0,0,0,.79-3.78c-.54-2,2.15-3.66,2.15-3.66s-1.82-1.61-2.94-2.73-2.12-4.4.81-5.57a7,7,0,0,1,5.61.32S231.26,60.88,240.46,62c5.76.67,6.67,5.42,18.69,11.49a35.2,35.2,0,0,0,22.58,3.44l-.69-.41h-3c-9.42,0-20.79-4.09-26.74-9-4.84-4-7.23-7.43-11.64-7.45",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    className: "cls-24",
    d: "M226.43,118.17l-.08.17c0,.16,0,.31-.06.49-.87,7.87,1.65,20.91,12,23.49,1.36.34,2.86.63,4.45.88-1.44-.34-2.93-.74-4.1-1.14-3.45-1.19-6.78-3.28-9.73-9.35s-2.46-14.54-2.46-14.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    className: "cls-26",
    d: "M288.19,109.26V110a2.12,2.12,0,0,0,0-.71m0,.71c-.12.79-.67,2.09-2.89,3.18-1.57.77-2.64-.38-3.33-1.85-3.77,3.14-6.76,8.6-6.76,8.6.89,8.43-2.31,18.35-9.45,22-2,1-3.65,1.81-5,2.4a97.8,97.8,0,0,0,15.09-1.21c9.4-1.7,10.88-15.52,10.88-15.52a10.35,10.35,0,0,0,4.29,1.75c1.86-9.63,2.31-10.05,2-13.68a19.08,19.08,0,0,0-.29-2,10,10,0,0,0-4.48,2.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    className: "cls-6",
    d: "M235.94,104.65c.78,0,1.41,1.18,1.41,2.64s-.63,2.63-1.41,2.63-1.41-1.18-1.41-2.63.63-2.64,1.41-2.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    className: "cls-6",
    d: "M259.29,104.65c.77,0,1.41,1.18,1.41,2.64s-.64,2.63-1.41,2.63-1.41-1.18-1.41-2.63.63-2.64,1.41-2.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    className: "cls-29",
    d: "M242.17,111.36s-3,2.4-2.5,5.2,4.09,2.81,4.09,2.81-2.54-.55-3.08-2.58,1.49-5.43,1.49-5.43",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    className: "cls-6",
    d: "M257.23,101.37s.76-.91,3.5-.75a6.84,6.84,0,0,1,4.5,2.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    className: "cls-6",
    d: "M232.6,101.39s.44-1.48,2.81-1.33a9.28,9.28,0,0,1,4.42,1.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    className: "cls-30",
    d: "M244.71,122.47c6,0,10.27-1.33,11.15,0s-.94,10.15-7.41,12.2-11.3-2.7-11.9-8.9c-.5-5,.61-4.3,2.62-3.83a36.78,36.78,0,0,0,5.54.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    className: "cls-6",
    d: "M237.45,121.56h-.08c0,1.34.16,3,.63,3.42.82.67,8.72.84,13,.6s4.22-1.17,4.33-2.4a11,11,0,0,0,0-1.15c-1.53-.55-5.42.44-10.6.44a36.78,36.78,0,0,1-5.54-.58,7.8,7.8,0,0,0-1.72-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    className: "cls-31",
    d: "M246.3,127.62a9.71,9.71,0,0,0-7.6,3.91,8.42,8.42,0,0,0,9.75,3.09,9.86,9.86,0,0,0,5-3.82,8.8,8.8,0,0,0-6.87-3.18h-.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    className: "cls-32",
    d: "M269.3,120.39l3.31,2,3.51.9s-.11-.13,2.49-2.2a4.82,4.82,0,0,1,4.92-1s-1.74-6.3.71-9.68a17,17,0,0,1,5.75-5l-6.57-5.67a13.08,13.08,0,0,0-8.82,4.7c-3.4,4.39-5.3,15.83-5.3,15.83",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    className: "cls-33",
    d: "M303,104.69s1.15-11.81-4.92-21-20.4-8.92-20.4-8.92,7.16,2.7,10.28,8.78,3.89,20.05,3.89,20.05a9.69,9.69,0,0,0,4.47,1.19,62,62,0,0,0,6.68-.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    className: "cls-33",
    d: "M268.81,92.58c7.52,3,10.76,2.23,12.15,2.81s3.79,5.53,3.79,5.53-4.25,5-5.19,9.45-2,4.4-2,4.4-.65,0-2.74,2.88a10,10,0,0,0-2.19,4.8S262,121.14,260,119.72s-8.58-9.13-20.34-8-13.16,7.72-14.22,8-4.15-1.12-4.5-2.84.15-9.58.15-9.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    className: "cls-34",
    d: "M289.75,103.7a29.74,29.74,0,0,0-3.31-20.34c-5.85-9.84-15.08-7.65-15.08-7.65l-2.15-.65s7.92-2.61,13.56,1.88,7.79,7.44,9.6,14.59c2.16,8.58.82,13.06.82,13.06Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    className: "cls-34",
    d: "M223.82,89.14c-4.69.63-6.88,3.34-7.24,10.42s.22,12.16,6.69,12.46,7-2,15.13-2.56,13.76,4.36,20.59,4.45,8.47.1,10.64-5.68,5-16.42-3.57-18.78-32.17-1.72-42.24-.31",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    className: "cls-34",
    d: "M295.46,100.87c8.1,0,14.66,7.21,14.66,16.09s-6.56,16.09-14.66,16.09S280.8,125.85,280.8,117s6.57-16.09,14.66-16.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    className: "cls-33",
    d: "M300.32,104.49c5.79,0,10.48,5.75,10.48,12.84s-4.69,12.84-10.48,12.84-10.48-5.75-10.48-12.84,4.69-12.84,10.48-12.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    className: "cls-32",
    d: "M300.32,109.89c3.34,0,6,3.33,6,7.44s-2.7,7.43-6,7.43-6-3.33-6-7.43,2.7-7.44,6-7.44",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    className: "cls-7",
    d: "M224.09,90.8c-2,.27-3.08.81-4,2s-1.52,3.4-1.69,6.79-.06,6.37.66,8.11,1.57,2.47,4.28,2.59a15.14,15.14,0,0,0,6.26-.87,33.15,33.15,0,0,1,8.64-1.68,27.86,27.86,0,0,1,11.58,2.1c3.32,1.19,6.23,2.31,9.17,2.35,3.42,0,5.3,0,6.21-.46s1.61-1.32,2.66-4.09,2.23-6.79,2.14-10.1A8.1,8.1,0,0,0,269,93.4a5.48,5.48,0,0,0-3.43-2.35c-3.81-1-11.88-1.53-20-1.49a184.36,184.36,0,0,0-21.4,1.24h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    className: "cls-35",
    d: "M248.9,89.58l-11.53,18.28.89-.07a26.1,26.1,0,0,1,10.37,1.68l13.06-19.13A119,119,0,0,0,248.9,89.58Zm-10.15.12c-3.86.13-7.52.36-10.58.64l-9.79,13.12a12.69,12.69,0,0,0,.71,4.28c.71,1.71,1.55,2.45,4.17,2.59Zm29.58,2.9-10.4,19.57a9.82,9.82,0,0,0,1.09.06c3.41,0,5.3,0,6.21-.46s1.61-1.32,2.65-4.08,2.24-6.8,2.15-10.1A8.19,8.19,0,0,0,269,93.4a5.91,5.91,0,0,0-.62-.8",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    className: "cls-38",
    d: "M35.12,150.65l127.58,16c1.61.2,3.5,2.43,4.24,5L206.69,308.9c.59,2-.11,3.44-1.55,3.17L89.45,290.92c-1.31-.24-3-2-3.74-4L34.26,154.75c-.95-2.45-.57-4.28.86-4.1",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    className: "cls-7",
    d: "M47,161.79,57,163.08c1.45.19,3.35,2.3,4.25,4.73l42,112.85c.75,2,.27,3.43-1.07,3.2L93,282.22c-1.33-.24-3-2-3.77-4L46.12,165.83c-.93-2.42-.52-4.22.91-4",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    className: "cls-7",
    d: "M72.16,175.92l10.49,1.41c1.34.18,3.06,2.1,3.84,4.29L123.1,284.49c.66,1.84.19,3.15-1.06,2.93l-9.74-1.75c-1.23-.22-2.76-1.87-3.44-3.71L71.22,179.55c-.8-2.19-.38-3.81.94-3.63",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    className: "cls-7",
    d: "M100.48,199.66l11.39,1.63c1.11.16,2.49,1.71,3.08,3.48l28.49,83.88c.51,1.53.09,2.61-.95,2.42l-10.71-1.91c-1-.18-2.29-1.56-2.83-3.08L99.61,202.55c-.62-1.75-.23-3,.87-2.89",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    className: "cls-7",
    d: "M132.75,237.06l12.78,2a3.13,3.13,0,0,1,1.89,2.13l16.82,52.11c.31,1,0,1.67-.65,1.54l-12.28-2.19a3,3,0,0,1-1.79-2l-17.38-51.9c-.36-1.06-.09-1.83.61-1.72",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    className: "cls-7",
    d: "M132.91,163.62c7.75,19.31,21.81,36.85,34.76,43.07,12.75,6.57,24,2.27,27.78-10.77,2.3-7.51,2.22-17.73-.3-28.72l-63.81-7.92Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    className: "cls-7",
    d: "M139.17,106.57c-2.07,1.06-4.28,1.81-5.86,3.77L162,156.68l31.24,3.79c-6.61-22.57-23.05-44.85-38.3-51.84-5.8-2.83-11.16-3.29-15.8-2.06",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    className: "cls-7",
    d: "M129.28,115.92c-4,8.79-4.14,22.34,0,36.78l28,3.41-26.52-42.59Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    className: "cls-7",
    d: "M109.36,173l22.8,3c.44.06,1.22,1.45,1.75,3.1s.59,2.93.15,2.88l-22.71-3c-.43,0-1.22-1.42-1.77-3.06s-.65-2.92-.22-2.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    className: "cls-7",
    d: "M112.54,182.45l22.66,3.06c.44.06,1.21,1.42,1.73,3.06s.58,2.88.15,2.82l-22.58-3.1c-.42-.06-1.2-1.4-1.75-3s-.63-2.87-.21-2.82",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    className: "cls-7",
    d: "M115.68,191.8l22.52,3.12c.43.06,1.19,1.41,1.7,3s.57,2.85.14,2.79l-22.43-3.17c-.43-.06-1.2-1.38-1.73-3s-.63-2.84-.2-2.78",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    className: "cls-7",
    d: "M118.77,201l39,5.55c.43.07,1.18,1.4,1.66,3s.52,2.81.09,2.75l-38.87-5.63c-.42-.06-1.19-1.37-1.71-2.93s-.62-2.8-.19-2.74",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    className: "cls-7",
    d: "M124.81,219l38.54,5.77c.43.06,1.16,1.36,1.63,2.91s.5,2.72.07,2.66l-38.39-5.83c-.42-.06-1.16-1.34-1.67-2.86s-.6-2.71-.18-2.65",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    className: "cls-7",
    d: "M121.81,210.08l38.78,5.67c.43.06,1.17,1.38,1.65,2.94s.51,2.77.08,2.71l-38.64-5.73c-.42-.06-1.17-1.36-1.69-2.9s-.6-2.75-.18-2.69",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    className: "cls-38",
    d: "M336.55,167.82,437.93,138.3c2.07-.6,2.9.95,1.86,3.48l-50,121.6a11.07,11.07,0,0,1-5.46,5.59L283.67,305.55c-2.34.85-3.46-.46-2.51-2.94L330.44,173.9c1-2.68,3.76-5.4,6.11-6.08",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    className: "cls-49",
    d: "M400.38,191.57C392.49,211,372.58,231.2,355.51,237c-17.44,5.88-25.57-5.38-17.75-25.48,7.92-20.35,28.89-41.33,46.39-46.55,17.13-5.1,24.2,7,16.23,26.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    className: "cls-7",
    d: "M309.86,265.38l32.47-11.2c2.21-.76,3.21.6,2.23,3.06L340.71,267a11.27,11.27,0,0,1-5.73,5.82l-32.43,11.5c-2.31.82-3.39-.52-2.43-3l3.82-9.91a11.33,11.33,0,0,1,5.92-6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    className: "cls-50",
    d: "M357.37,249.3,388,238.72c2.09-.72,3,.63,2,3l-3.88,9.48a11,11,0,0,1-5.52,5.63L350,267.75c-2.18.77-3.16-.56-2.19-3l3.86-9.68a11.13,11.13,0,0,1,5.7-5.78",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    className: "cls-51",
    d: "M378,201.79c-4.06,4.75-8.57,8.18-12.37,9.41s-6.49.16-7.49-2.91c-8.69,6.31-16.87,16.15-20.8,25.79,3.38,4.65,9.94,5.67,18.22,2.88s17.46-9.06,25.8-17.48c3.66-9.44,2.11-16-3.36-17.69",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    className: "cls-51",
    d: "M384.43,189.28c-3.56,8.88-11.59,17.7-18,19.77s-8.87-3.47-5.32-12.46,11.75-18,18.22-20,8.67,3.75,5.1,12.67",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    className: "cls-52",
    d: "M370.24,22.71v32.1l-18-4.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    className: "cls-53",
    d: "M370.24,22.71v32.1l18-4.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    className: "cls-54",
    d: "M370.24,54.81V79.69L352.21,50Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    className: "cls-55",
    d: "M370.24,54.81V79.69l18-29.71Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    className: "cls-52",
    d: "M38.07,320.51V373L8.59,365.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    className: "cls-53",
    d: "M38.07,320.51V373l29.48-7.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    className: "cls-54",
    d: "M38.07,373v40.7L8.59,365.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    className: "cls-55",
    d: "M38.07,373v40.7l29.48-48.59Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    className: "cls-52",
    d: "M431.11,228.15v45.49l-25.53-6.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    className: "cls-53",
    d: "M431.11,228.15v45.49l25.53-6.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    className: "cls-54",
    d: "M431.11,273.64v35.25l-25.53-42.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    className: "cls-55",
    d: "M431.11,273.64v35.25l25.53-42.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    className: "cls-7",
    d: "M454.56,0h11.23a10.94,10.94,0,0,1,10.93,10.93h0V57.37A10.94,10.94,0,0,1,465.79,68.3H454.56a10.94,10.94,0,0,1-10.92-10.93V10.93A10.92,10.92,0,0,1,454.56,0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    className: "cls-7",
    d: "M141.94,354.47h11.22a10.94,10.94,0,0,1,10.93,10.92h0v46.44a10.94,10.94,0,0,1-10.93,10.93H141.94A10.93,10.93,0,0,1,131,411.83V365.39a10.92,10.92,0,0,1,10.93-10.92h0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    className: "cls-7",
    d: "M115,374.89h11.22a10.92,10.92,0,0,1,10.92,10.92h0v46.44a10.92,10.92,0,0,1-10.92,10.92H115a10.92,10.92,0,0,1-10.93-10.92V385.82A10.93,10.93,0,0,1,115,374.89h0",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    className: "cls-7",
    d: "M17.69,189.77H28.92A10.92,10.92,0,0,1,39.84,200.7h0v46.44a10.93,10.93,0,0,1-10.92,10.93H17.69A10.92,10.92,0,0,1,6.77,247.14h0V200.7a10.92,10.92,0,0,1,10.92-10.93",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    className: "cls-5",
    d: "M355.47,111.55H333.92l10.77-18.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    className: "cls-5",
    d: "M223,22H201.43L212.21,3.29Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    className: "cls-5",
    d: "M55.08,277.16H33.53L44.3,258.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    className: "cls-5",
    d: "M211.82,349.93H190.28l10.77-18.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    className: "cls-7",
    x: 16.07,
    y: 6.24,
    width: 46.25,
    height: 46.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    className: "cls-64",
    y: 28.45,
    width: 46.25,
    height: 46.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    className: "cls-66",
    d: "M50.34,26.92,64.16,7V53.2l-13.82,20Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    className: "cls-64",
    d: "M14,4.13.16,24.1H46.41l13.82-20Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    className: "cls-7",
    x: 368.43,
    y: 358.77,
    width: 46.25,
    height: 46.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    className: "cls-64",
    x: 352.36,
    y: 380.98,
    width: 46.25,
    height: 46.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    className: "cls-66",
    d: "M402.69,379.44l13.83-20v46.25l-13.83,20Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    className: "cls-64",
    d: "M366.34,356.66l-13.83,20h46.25l13.83-20Z",
    transform: "translate(0 0)"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTechImg);
export default __webpack_public_path__ + "static/media/hero-tech-img.0b103ac5ed154e58e398d710b2665df6.svg";
export { ForwardRef as ReactComponent };